/**
 * PasswordReset selector functions
 */
import { createSelector } from 'reselect';

const loginReducer = (state) => state.get('loginReducer');

/**
 * Retrieves loading state from login reducer
 */
export const loadingSelector = createSelector(loginReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from login reducer
 */
export const errorSelector = createSelector(loginReducer, (state) =>
  state.get('error'),
);

export const required2FASelector = createSelector(loginReducer, (state) =>
  state.get('is2FARequired'),
);

export const loginPossible2faMethods = createSelector(loginReducer, (state) =>
  state.get('possible2faMethods'),
);
